import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "display"]

  connect() {
    this.refreshDisplay()
  }

  issuingBodyFor(aibAccountNumber) {
    const hubs = {
      "02": "HUB Denmark",
      "06": "HUB Italy",
      "07": "HUB Netherlands",
      "08": "HUB Norway",
      12: "HUB Österreich",
      17: "HUB Slovenia",
      19: "HUB Portugal",
      21: "HUB Cyprus TSO",
      22: "HUB Czech Republic",
      23: "HUB Estonia",
      27: "HUB Lithuania",
      29: "HUB Belgien VREG",
      32: "HUB Schweiz Pronovo",
      33: "HUB Belgien Wallonia",
      34: "HUB Belgien Cervere",
      35: "HUB Frankreich",
      36: "HUB Luxembourg",
      37: "HUB Iceland",
      38: "HUB Germany UBA",
      39: "HUB Ireland",
      40: "HUB Croatia",
      41: "HUB Finnland",
      42: "HUB Spain",
      43: "HUB Belgien CREG",
      52: "HUB Sweden Cesar",
    }

    return hubs[String(aibAccountNumber).substr(0, 2)] || ""
  }

  refreshDisplay() {
    const aibAccountNumber = this.inputTarget.value.trim()
    this.displayTarget.textContent = this.issuingBodyFor(aibAccountNumber)
  }
}
